import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { unstable_HistoryRouter as HistoryRouter, useLocation } from 'react-router-dom'
import Layouts from './layouts'
import history from './appHistory'
import ContentPublishQueueRunner from 'components/ContentPublishQueueRunner'
// import { auth } from 'auth/FirebaseAuth'
import {
  showLoading,
  signOut,
  tokenGenerator,
  restoreSession,
} from 'store/slices/authSlice'
// import FirebaseService from 'services/FirebaseService'
// import { isSubAdminEmailVerified } from 'utils/isEmailVerifiedClaim'
import { clearAppConstants } from 'store/slices/appConstantsSlice'
import { AUTH_TOKEN, AUTH_DEVICE_TOKEN } from 'constants/AuthConstant'
const themes = {
  dark: `${process.env.PUBLIC_URL}/css/dark-theme.css`,
  light: `${process.env.PUBLIC_URL}/css/light-theme.css`,
}

function ScrollToTop() {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}

function App() {
  const dispatch = useDispatch()
  const { currentTheme } = useSelector((state) => state.theme)

  useEffect(() => {
    const generateToken = async () => {
      const currentToken = await tokenGenerator()
      if (currentToken) {
        localStorage.setItem(AUTH_DEVICE_TOKEN, currentToken)
      }
    }
    generateToken()
  }, [])

  useEffect(() => {
    const boot = async () => {
      const token = window.localStorage.getItem(AUTH_TOKEN)
      if (!token) {
        dispatch(clearAppConstants())
        dispatch(showLoading(false))
        return
      }

      try {
        const result = await dispatch(restoreSession())
        if (restoreSession.rejected.match(result)) {
          // 'unauthorized' / 'invalid-session' / 'no-token' → sign out
          dispatch(signOut())
        }
      } catch (error) {
        console.error('Session restore failed', error)
        dispatch(signOut())
      } finally {
        dispatch(showLoading(false))
      }
    }

    boot()

    // ------- Firebase auth (legacy) -----------
    // auth.onAuthStateChanged(async (user) => {
    //   if (!user) {
    //     dispatch(clearAppConstants())
    //   }
    //   if (user) {
    //     const idTokenResult = await user.getIdTokenResult(true)
    //     const claims = idTokenResult.claims;
    //     const userType = idTokenResult.claims.userType
    //     if (userType === 'Sub-admin' && !isSubAdminEmailVerified(user, claims)) {
    //       await FirebaseService.signOutRequest()
    //       window.localStorage.removeItem(AUTH_TOKEN)
    //       localStorage.removeItem('expiresAt')
    //       dispatch(
    //         showAuthMessage({
    //           message:
    //             'Please verify your email before signing in. Check your inbox for the verification link.',
    //           durationMs: 10000,
    //         })
    //       )
    //       dispatch(showLoading(false))
    //       return
    //     }
    //
    //     window.localStorage.setItem(AUTH_TOKEN, idTokenResult.token)
    //     const expiresAt = new Date(idTokenResult.expirationTime).getTime()
    //     localStorage.setItem('expiresAt', expiresAt);
    //     await userService.establishSession(idTokenResult.token)
    //     if (userType === 'Admin') {
    //       const constantsPayload = await constantsService.getConstants()
    //       if (constantsPayload) {
    //         dispatch(setAppConstants(constantsPayload))
    //       }
    //       const userData = {
    //         userType,
    //         firstName: claims.firstName,
    //         lastName: claims.lastName,
    //         email: claims.email,
    //         phone: claims.phoneNumber,
    //         displayImage: user.photoURL || "",
    //         emailVerified: user.emailVerified,
    //         phoneVerified: user.phoneNumber ? true : false,
    //       }
    //       dispatch(
    //         authenticated({ user: userData, token: idTokenResult.token })
    //       )
    //       dispatch(showLoading(false))
    //     }
    //     else if (userType === 'Sub-admin') {
    //       const data = await subadminService.getDetailForProfile()
    //       if (data) {
    //         const constantsPayload = await constantsService.getConstants()
    //         if (constantsPayload) {
    //           dispatch(setAppConstants(constantsPayload))
    //         }
    //         const userData = {
    //           userType,
    //           firstName: claims.firstName,
    //           middleName: data.user?.middleName,
    //           lastName: claims.lastName,
    //           email: claims.email,
    //           phone: claims.phoneNumber,
    //           permissions: data.user?.permissions,
    //           displayImage: user?.photoURL ? user.photoURL : null,
    //           emailVerified: user.emailVerified,
    //           phoneVerified: user.phoneNumber ? true : false,
    //         }
    //         dispatch(
    //           authenticated({ user: userData, token: idTokenResult.token })
    //         )
    //         dispatch(showLoading(false))
    //       }
    //       dispatch(showLoading(false))
    //     }
    //     else {
    //       dispatch(signOut())
    //       dispatch(showLoading(false))
    //     }
    //   } else {
    //     dispatch(showLoading(false))
    //   }
    // })
    // -----------------------------------------

  }, [dispatch])

  useEffect(() => {
    const themeHref = themes[currentTheme] || themes.light
    let themeLink = document.getElementById('legacy-theme-css')
    if (!themeLink) {
      themeLink = document.createElement('link')
      themeLink.id = 'legacy-theme-css'
      themeLink.rel = 'stylesheet'
      document.head.appendChild(themeLink)
    }
    themeLink.href = themeHref
  }, [currentTheme])

  return (
    <div className="App">
      <HistoryRouter history={history}>
        <ScrollToTop />
        <ContentPublishQueueRunner />
        <Layouts />
      </HistoryRouter>
    </div>
  )
}

export default App
